"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faImage = require("@fortawesome/pro-regular-svg-icons/faImage");

var _core = require("@chakra-ui/core");

var _imageTypes = require("./imageTypes");

var _excluded = ["state"];

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ImageStyles = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: ", ";\n    align-items: center;\n    overflow: auto;\n    border: 0px;\n    min-height: 40px;\n    margin-bottom: -1px;\n\n    a {\n        display: flex;\n        width: ", ";\n    }\n\n    img {\n        max-width: none;\n        width: ", ";\n        align-self: center;\n        transition: border-radius 0.1s ease-in-out;\n        border-radius: ", ";\n        filter: ", ";\n    }\n"])), function (props) {
  return props.alignment;
}, function (props) {
  return props.alignment == 'fill' ? '100%' : 'auto';
}, function (props) {
  return props.alignment == 'fill' ? '100%' : 'auto';
}, function (props) {
  return props.imageStyle == 'round' ? '50%' : 0;
}, function (props) {
  switch (props.imageStyle) {
    case 'greyscale':
      return "grayscale(1)";

    case 'invert':
      return "invert(1)";

    case 'blur':
      return "blur(2px)";

    default:
      return "none";
  }
});

var Icon = function Icon() {
  return /*#__PURE__*/_react["default"].createElement(_core.Flex, {
    py: 10,
    justifyContent: "center",
    alignItems: "center",
    w: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faImage.faImage,
    size: "6x"
  }));
};

var ImageContent = function ImageContent(props) {
  var _props$url = props.url,
      url = _props$url === void 0 ? '' : _props$url,
      _props$mobileUrl = props.mobileUrl,
      mobileUrl = _props$mobileUrl === void 0 ? '' : _props$mobileUrl,
      _props$alt = props.alt,
      alt = _props$alt === void 0 ? '' : _props$alt,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      _props$link = props.link,
      link = _props$link === void 0 ? '' : _props$link,
      _props$openInNewTab = props.openInNewTab,
      openInNewTab = _props$openInNewTab === void 0 ? false : _props$openInNewTab,
      _props$loadingMethod = props.loadingMethod,
      loadingMethod = _props$loadingMethod === void 0 ? 'normal' : _props$loadingMethod,
      _props$imageZoom = props.imageZoom,
      imageZoom = _props$imageZoom === void 0 ? 'none' : _props$imageZoom,
      isEditMode = props.isEditMode,
      _props$alignment = props.alignment,
      alignment = _props$alignment === void 0 ? 'fill' : _props$alignment;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, link.length > 0 && !['magnify', 'lightbox'].includes(imageZoom) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Link, {
    onClick: function onClick(e) {
      return isEditMode && e.preventDefault();
    },
    rel: openInNewTab ? 'nofollow noreferrer' : '',
    href: link,
    target: openInNewTab ? '_blank' : '_self'
  }, /*#__PURE__*/_react["default"].createElement(_imageTypes.StandardImage, {
    title: title.length > 0 ? title : alt,
    alt: alt,
    url: url,
    mobileUrl: mobileUrl,
    loadingMethod: loadingMethod,
    isFullWidth: alignment === 'fill'
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (!imageZoom || imageZoom === 'none') && /*#__PURE__*/_react["default"].createElement(_imageTypes.StandardImage, {
    title: title.length > 0 ? title : alt,
    alt: alt,
    url: url,
    mobileUrl: mobileUrl,
    loadingMethod: loadingMethod,
    isFullWidth: alignment === 'fill'
  }), imageZoom === 'magnify' && /*#__PURE__*/_react["default"].createElement(_imageTypes.MagnifyImage, props), imageZoom === 'lightbox' && /*#__PURE__*/_react["default"].createElement(_imageTypes.LightboxImage, props)));
};

var ImageRenderer = function ImageRenderer(_ref) {
  var _window, _window$location;

  var state = _ref.state,
      props = _objectWithoutProperties(_ref, _excluded);

  var _state$alignment = state.alignment,
      alignment = _state$alignment === void 0 ? 'fill' : _state$alignment,
      imageStyle = state.imageStyle,
      url = state.url;
  var inStorefront = !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname.includes('/content/edit/'));
  return /*#__PURE__*/_react["default"].createElement(ImageStyles, {
    alignment: alignment,
    imageStyle: imageStyle,
    className: "content__image"
  }, url && url.length > 0 ? /*#__PURE__*/_react["default"].createElement(ImageContent, _extends({}, state, props)) : inStorefront ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement(Icon, null));
};

var _default = ImageRenderer;
exports["default"] = _default;